import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./Card.css";
import * as React from "react";
import { Surface, SurfaceContext } from '../../Surface';
import { css } from '../../Util';
export var CustomCard = function (props) {
    return (React.createElement(SurfaceContext.Consumer, null, function (surfaceContext) { return (React.createElement(Surface, tslib_1.__assign({}, surfaceContext, { spacing: 1 /* default */ }),
        React.createElement("div", { className: css(props.className, "bolt-card flex-column depth-8", surfaceContext.background === 1 /* neutral */ && "bolt-card-white") }, props.children))); }));
};
